import React, { useState } from "react"
import { Link } from "react-router-dom"
import { formatINR } from "../constants"

export default function AgingTable({ byProject = [], byCustomer = [] }) {
  const [view, setView] = useState("project")

  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
      <div className="flex items-center gap-1 border-b border-slate-200 px-4">
        <ViewTab active={view === "project"} onClick={() => setView("project")}>
          By Project
        </ViewTab>
        <ViewTab active={view === "customer"} onClick={() => setView("customer")}>
          By Customer
        </ViewTab>
      </div>

      {view === "project" ? (
        <ProjectView rows={byProject} />
      ) : (
        <CustomerView rows={byCustomer} />
      )}
    </div>
  )
}

function ProjectView({ rows }) {
  if (!rows.length) {
    return <EmptyRow message="No outstanding installments by project." />
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-[13px]">
        <thead className="bg-slate-50 text-left text-slate-500">
          <tr>
            <th className="px-4 py-2.5 font-medium">Project</th>
            <th className="px-4 py-2.5 font-medium text-right">Current</th>
            <th className="px-4 py-2.5 font-medium text-right">0–30d</th>
            <th className="px-4 py-2.5 font-medium text-right">31–60d</th>
            <th className="px-4 py-2.5 font-medium text-right">61–90d</th>
            <th className="px-4 py-2.5 font-medium text-right">90+d</th>
            <th className="px-4 py-2.5 font-medium text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.project.id} className="border-t border-slate-100 hover:bg-slate-50/50">
              <td className="px-4 py-2.5 font-medium text-slate-900">{row.project.name}</td>
              <td className="px-4 py-2.5 text-right text-slate-600">{formatINR(row.current)}</td>
              <td className="px-4 py-2.5 text-right text-emerald-600">{formatINR(row.b0_30)}</td>
              <td className="px-4 py-2.5 text-right text-amber-600">{formatINR(row.b31_60)}</td>
              <td className="px-4 py-2.5 text-right text-orange-600">{formatINR(row.b61_90)}</td>
              <td className="px-4 py-2.5 text-right text-red-600">{formatINR(row.b90_plus)}</td>
              <td className="px-4 py-2.5 text-right font-medium text-slate-900">{formatINR(row.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

function CustomerView({ rows }) {
  if (!rows.length) {
    return <EmptyRow message="No overdue customers." />
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-[13px]">
        <thead className="bg-slate-50 text-left text-slate-500">
          <tr>
            <th className="px-4 py-2.5 font-medium">Customer</th>
            <th className="px-4 py-2.5 font-medium text-right">Overdue Amount</th>
            <th className="px-4 py-2.5 font-medium text-right">Oldest (days)</th>
            <th className="px-4 py-2.5 font-medium">Booking</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className="border-t border-slate-100 hover:bg-slate-50/50">
              <td className="px-4 py-2.5 font-medium text-slate-900">{row.customer_name}</td>
              <td className="px-4 py-2.5 text-right text-red-600 font-medium">
                {formatINR(row.total_overdue)}
              </td>
              <td className="px-4 py-2.5 text-right text-slate-600">{row.oldest_days}d</td>
              <td className="px-4 py-2.5">
                <Link
                  to={`/bookings/${row.booking_id}`}
                  className="text-blue-600 hover:underline"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

function ViewTab({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-3 text-[13px] font-medium border-b-2 transition-colors ${
        active
          ? "border-slate-900 text-slate-900"
          : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
      }`}
    >
      {children}
    </button>
  )
}

function EmptyRow({ message }) {
  return (
    <div className="px-6 py-10 text-center text-[13px] text-slate-400">
      {message}
    </div>
  )
}
